<template>
  <form @submit.prevent="submitForm" class="space-y-4">
    <div>
      <label for="original_url" class="text-sm font-medium text-gray-700 flex">
        {{ t('slides_editor.components.video_form.video_url') }}
      </label>
      <input
        type="text"
        id="original_url"
        v-model="block.embed.original_url"
        @input="debouncedSubmit"
        class="mt-1 block w-full rounded-xl border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-black/50"
      >

      <div class="flex text-xs text-gray-500 items-center mt-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 mr-1">
          <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
        </svg>

        <p class="italic">{{ t('slides_editor.components.video_form.youtube_support') }}</p>
      </div>
    </div>
    <div v-if="block.embed.provider == 'youtube'" class="flex w-100 gap-4">
      <div class="grow">
        <label for="start" class="block text-sm font-medium text-gray-700">{{ t('slides_editor.components.video_form.start_time') }}</label>
        <input
          type="text"
          id="start"
          v-model="block.embed.start"
          @input="debouncedSubmit"
          class="mt-1 block w-full rounded-xl border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-black/50"
        >
      </div>
      <div class="grow">
        <label for="end" class="block text-sm font-medium text-gray-700">{{ t('slides_editor.components.video_form.end_time') }}</label>
        <input
          type="text"
          id="end"
          v-model="block.embed.end"
          @input="debouncedSubmit"
          class="mt-1 block w-full rounded-xl border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-black/50"
        >
      </div>
    </div>
    <div v-if="errorMessage" class="text-red-500 text-sm">{{ errorMessage }}</div>
  </form>
</template>

<script>
import { ref } from 'vue'
import { useBlockUpdate } from '../../composables/useBlockUpdate'
import debounce from 'debounce'
import { t } from '@/libs/i18n'

export default {
  name: 'VideoForm',
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { onBlockUpdate } = useBlockUpdate(props.block)
    const errorMessage = ref('')

    const validateForm = () => {
      if (parseFloat(props.block.embed.end) <= parseFloat(props.block.embed.start)) {
        errorMessage.value = t('slides_editor.components.video_form.validation_error')
        return false
      }
      errorMessage.value = ''
      return true
    }

    const submitForm = () => {
      if (!validateForm()) return

      onBlockUpdate(props.block.embed, 'embed_attributes')
    }

    const debouncedSubmit = debounce(submitForm, 2000)

    return {
      debouncedSubmit,
      errorMessage,
      t
    }
  }
}
</script>
